module.exports = __webpack_public_path__ + "static/media/logos_super2000_limagengibre.f44a8e86.png";